module.exports = __webpack_public_path__ + "static/img/location-information_1.c8c03036.svg";